import React, { useState, useEffect, useContext } from 'react';
import './ShipmentManagementHeader.scss';
import ShipmentAdd from '../../ShipmentAdd/ShipmentAdd';
import { useNavigate, useLocation } from 'react-router-dom';
import { getIcon } from '../../../utils/images';
import { Button, Dropdown } from 'antd';
import NowlunFormContext from '../../../context/NowlunFormContext';

const ShipmentManagementHeader = ({ refetch, archiveTotal }) => {
  const location = useLocation();

  const [showAddForm, setShowAddForm] = useState(false || location.hash.includes('add'));
  const [showAddCsvForm, setShowAddCsvForm] = useState(false);
  const navigate = useNavigate();
  const { setShowNowlunForm, showNowlunForm, setCurrentShipment, currentShipment } = useContext(NowlunFormContext);

  function openHeader() {
    setShowAddForm(true);
  }

  function closeHeader() {
    setShowAddForm(false);
    setShowAddCsvForm(false);
    setShowNowlunForm(false);
  }

  function openAddTrackHeader() {
    setShowAddForm(true);
  }

  function openAddCsvTrackHeader() {
    setShowAddCsvForm(true);
  }

  function onTabChange(tab) {
    if (tab === 'nowlun') {
      setShowAddForm(false);
      setShowNowlunForm(true);
      setCurrentShipment(null);
    }
  }

  useEffect(() => {
    window.addEventListener('track', () => openHeader());
  }, [refetch]);

  const items = [
    {
      key: '1',
      label: (
        <div className="add-shipment-option-wrapper" onClick={openAddTrackHeader}>
          <img src={getIcon('add-shipment-icon')} />
          Add New Shipment
        </div>
      ),
    },
    {
      key: '2',
      label: (
        <div className="add-shipment-option-wrapper" onClick={openAddCsvTrackHeader}>
          <img src={getIcon('upload-csv-track')} />
          Upload Excel Sheet
        </div>
      ),
    },
  ];

  return (
    <div className="ShipmentManagementHeader">
      <div className="title-header">
        <div className="title">Management Dashboard</div>
        <Button className="link-btn archive-btn" onClick={() => navigate('/shipment_management/archive')}>
          Archive ({archiveTotal})
        </Button>
      </div>
      <div className="dropdown-container">
        <div className="actions">
          <Button className="bold-btn" onClick={() => navigate('/search_price')}>
            Instant Prices
          </Button>
          <Dropdown menu={{ items }} placement="bottom">
            <Button className="bold-btn">
              <div className="add-shipment-wrapper">
                <span>Add Shipment</span>
                <img src={getIcon('dropdown-arrow')} />
              </div>
            </Button>
          </Dropdown>
        </div>
      </div>
      {showAddForm &&
        <ShipmentAdd close={closeHeader} refetch={refetch} showSingle={showAddForm} onTabChange={onTabChange} />}
      {showAddCsvForm && <ShipmentAdd close={closeHeader} refetch={refetch} showCSV={showAddCsvForm} />}
      {showNowlunForm &&
        <ShipmentAdd close={closeHeader} refetch={refetch} showNowlunForm={showNowlunForm}
                     shipment={currentShipment} />}
    </div>
  );
};

export default ShipmentManagementHeader;
